import { useContext, useEffect } from 'react';
import Context from '../../../../container';

/**
 * 深色首屏期间把官网顶栏（Ceiling）切到 dark 主题（白色 logo 与文字），
 * 滚过首屏后恢复默认（浅色背景用）主题。
 * 行为对齐官网 Banner 组件 covered 模式下的明暗自动切换。
 */
export default function useCeilingTheme(heroSelector: string) {
  const { dispatch } = useContext(Context);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return undefined;
    }

    const hero = document.querySelector(heroSelector);
    if (!hero) {
      return undefined;
    }

    const apply = () => {
      const rect = hero.getBoundingClientRect();
      const overHero = rect.bottom > 88;
      dispatch({ theme: overHero ? 'dark' : undefined });
    };

    apply();
    window.addEventListener('scroll', apply, { passive: true });
    window.addEventListener('resize', apply);

    return () => {
      window.removeEventListener('scroll', apply);
      window.removeEventListener('resize', apply);
      dispatch({ theme: undefined });
    };
  }, [dispatch, heroSelector]);
}
